<template>
  <div class="page">
    <div class="container bikentapedia-container">
      <h1 class="px-3 py-5 background-gray">
        {{ $t("page.headers.bikentapedia") }}
      </h1>
      <collapsible-article
        v-for="(article, index) in articles"
        :key="index"
        :article="article"
      />
    </div>
  </div>
</template>

<script>
import CollapsibleArticle from "@/components/CollapsibleArticle"
import BikentapediaMixin from "@/mixins/BikentapediaMixin"

export default {
  name: "Bikentapedia",
  components: { CollapsibleArticle },
  mixins: [BikentapediaMixin],
}
</script>
